import { SignInIdentifier } from '@logto/schemas';
import { useTranslation } from 'react-i18next';

import styles from './index.module.scss';

type Props = {
  readonly options: SignInIdentifier[];
  readonly selected?: SignInIdentifier;
  readonly onChange: (identifier: SignInIdentifier) => void;
};

const IdentifierTypeSelector = ({ options, selected, onChange }: Props) => {
  const { t } = useTranslation();

  if (options.length < 2) {
    return null;
  }

  const labels = options.map((identifier) =>
    identifier === SignInIdentifier.Email
      ? String(t('input.email'))
      : identifier === SignInIdentifier.Phone
        ? String(t('input.phone_number'))
        : String(t('input.username'))
  );

  return (
    <div className={styles.container} role="group" aria-label={labels.join(' / ')}>
      {options.map((identifier, index) => {
        const isSelected = identifier === selected;
        const label = labels[index];

        return (
          <button
            key={identifier}
            className={isSelected ? styles.selected : styles.option}
            type="button"
            aria-pressed={isSelected}
            onClick={() => {
              onChange(identifier);
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default IdentifierTypeSelector;
